const BlankNodeTypeEnum = {
    ANONYMOUS_ANNOTATION: 'ANONYMOUS_ANNOTATION',
    LOGICAL_AXIOM: 'LOGICAL_AXIOM',
    AXIOM_ANNOTATION: 'AXIOM_ANNOTATION'
};

export default BlankNodeTypeEnum;